<!--
 * @Descripttion: 
 * @Author: congz
 * @Date: 2020-07-22 13:14:57
 * @LastEditors: congz
 * @LastEditTime: 2020-08-13 10:34:49
--> 
<template>
  <div class="order-details" id="order-details" name="order-details">
    <div class="order-details-layout" v-if="order">
      <el-row :gutter="10">
        <div>
          <CenterMenu></CenterMenu>
        </div>
        <el-col :span="20">
          <div class="order-details-content">
            <div class="extra"></div>
            <div class="order-details-title">
              <p>Order Details</p>
            </div>
            <div class="order-operate">
              <div class="order-num">Order Number ：{{order.order_num}}</div>
              <div class="order-button" v-if="order.type !== 2 && order.pay_method === 'online'">
                <el-button class="pay" size="small" style="width:120px" @click="payNow">Pay Now</el-button>
              </div>
            </div>
            <div class="order-step-info" v-if="order.type !== 2">Awaiting payment</div>
            <div class="order-success-info" v-else>Paid</div>
            <div class="order-step">
              <el-steps
                :space="200"
                :active="order.type === 2 ? 3 : 1"
                finish-status="success"
                align-center
              >
                <el-step title="Order placed" :description="order.created_at| dateFormat"></el-step>
                <el-step title="Payment"></el-step>
                <el-step title="Shipped"></el-step>
              </el-steps>
            </div>
            <div class="extra"></div>
            <div class="extra"></div>

            <div class="order-list-product">
              <div class="pro-img">
                <router-link :to="{ path: '/goods/details', query: {productID:order.product_id} }">
                  <img :src="order.img_path" />
                </router-link>
              </div>
              <div class="pro-info">
                <span style="margin-bottom:7px">
                  <router-link
                    class="info-href"
                    :to="{ path: '/goods/details', query: {productID:order.product_id} }"
                  >{{order.name}}</router-link>
                </span>
              </div>
              <div class="pro-price">
                <span>
                  {{order.discount_price}}₹&nbsp;×
                  {{order.num}}
                </span>
              </div>
            </div>
            <div class="order-address-title">Shipping Information</div>
            <div class="order-address">
              <div class="order-address-head">
                <p>Name:</p>
                <p>Phone number :</p>
                <p>Receiving address :</p>
              </div>
              <div class="order-address-data">
                <p>{{order.address_name}}</p>
                <p>{{order.address_phone}}</p>
                <p>{{order.address}}</p>
              </div>
            </div>
            <div class="order-address-title">Payment Method</div>
            <div class="order-address">
              <div class="order-address-head">
                <p>Payment Method ：</p>
              </div>
              <div class="order-address-data">
                <p>{{order.pay_method === 'online' ? 'Online Payment (UPI)' : 'Cash on Delivery'}}</p>
              </div>
            </div>
            <div class="order-address-title">Invoice Information</div>
            <div class="order-address">
              <div class="order-address-head">
                <p>Invoice Type ：</p>
                <p>Invoice content ：</p>
                <p>Invoice Title ：</p>
              </div>
              <div class="order-address-data">
                <p>Electronic ordinary invoice</p>
                <p>Purchase product details</p>
                <p>individual</p>
              </div>
            </div>
            <!-- 结算列表 -->
            <div class="section-count">
              <div class="money-box">
                <ul>
                  <li>
                    <span class="title">Number of products：</span>
                    <span class="value">{{order.num}}</span>
                  </li>
                  <li>
                    <span class="title">Total product price：</span>
                    <span class="value">{{order.discount_price}}₹</span>
                  </li>
                  <li>
                    <span class="title">Promotional Offer：</span>
                    <span class="value">-0₹</span>
                  </li>
                  <li>
                    <span class="title">Promotional Offer：</span>
                    <span class="value">-0₹</span>
                  </li>
                  <li>
                    <span class="title">shipping cost：</span>
                    <span class="value">0₹</span>
                  </li>
                  <li class="total">
                    <span class="title">Total payable amount：</span>
                    <span class="value">
                      <span class="total-price">{{order.num*order.discount_price}}</span>₹
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="not-found" v-else>Unable to find the order</div>
    <!-- UPI支付弹窗 -->
    <el-dialog title="UPI Payment" :visible.sync="upiDialogVisible" width="350px" center>
      <div v-if="upiLoading" style="text-align:center;padding:40px 0;">
        <i class="el-icon-loading" style="font-size:40px;color:#B9365B;"></i>
        <p style="margin-top:15px;color:#757575;">Processing payment...</p>
      </div>
      <div v-else style="text-align:center;">
        <p style="margin-bottom:15px;color:#333;font-size:16px;">Scan the QR code to pay</p>
        <img src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=upi://pay?pa=ssptecho32@gmail.com&pn=Clothique&cu=INR" alt="UPI QR Code" style="width:200px;height:200px;" />
        <p style="margin-top:15px;color:#B9365B;font-weight:600;">Amount: {{payAmount}}₹</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="upiDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="handleUpiDone">Done</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import CenterMenu from '../components/CenterMenu'
import * as ordersAPI from '@/api/orders'
export default {
  name: 'OrderDetails',
  data() {
    return {
      orderNum: '', // 订单num,
      order: '',
      address: '',
      upiDialogVisible: false,
      upiLoading: true,
      payAmount: 0,
      pollTimer: null
    }
  },
  activated() {
    if (this.$route.query.orderNum != undefined) {
      this.orderNum = this.$route.query.orderNum
      this.load()
    }
  },
  deactivated() {
    this.stopPolling()
  },
  beforeDestroy() {
    this.stopPolling()
  },
  watch: {
    // 监听orderNum变化，重新加载
    orderNum: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.load()
      }
    }
  },
  methods: {
    load() {
      ordersAPI
        .showOrder(this.orderNum)
        .then(res => {
          if (res.status === 200) {
            this.order = res.data
            // If order is unpaid online payment, start polling
            if (res.data && res.data.type !== 2 && res.data.pay_method === 'online') {
              this.startPolling()
            } else {
              this.stopPolling()
            }
          } else if (res.status === 20001) {
            //token过期，需要重新登录
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Failed to obtain order', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain order', err)
        })
    },
    payNow() {
      this.$router.push({ path: '/payment', query: { orderNum: this.order.order_num } })
    },
    handleUpiDone() {
      this.upiDialogVisible = false
      this.notifyError('Not paid', '')
    },
    startPolling() {
      this.stopPolling()
      this.pollTimer = setInterval(() => {
        ordersAPI.showOrder(this.orderNum).then(res => {
          if (res.status === 200 && res.data) {
            this.order = res.data
            if (res.data.type === 2) {
              this.stopPolling()
              this.notifySucceed('Payment confirmed!')
            }
          }
        }).catch(() => {})
      }, 5000)
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    }
  },
  components: {
    CenterMenu
  }
}
</script>
<style scoped>
.order-details-layout {
  max-width: 1225px;
  margin: 0 auto;
}
.order-details-content {
  background-color: #ffffff;
  margin-bottom: 30px;
}
.order-details-title {
  height: 100px;
  display: flex;
  align-items: center;
}
.order-details-title p {
  font-size: 30px;
  color: #757575;
  margin-left: 50px;
}
.extra {
  height: 10px;
}
/*订单号按钮区域*/
.order-details-content .order-operate {
  width: 920px;
  margin: 0 auto;
  display: flex;
  border-bottom: 1px solid #e0e0e0;
}
.order-details-content .order-operate .order-num {
  width: 500px;
  font-size: 18px;
  margin-bottom: 17px;
  color: #242424;
}
.order-details-content .order-operate .order-button {
  margin-left: 170px;
}
.order-details-content .order-operate .order-button .pay {
  margin-left: 10px;
  background-color: #B9365B;
  color: #ffffff;
}
/*订单号按钮区域END*/
/*进度条区域*/
.order-details-content .order-step-info {
  width: 920px;
  margin: 0 auto;
  color: #B9365B;
  font-size: 18px;
  margin-top: 20px;
}
.order-details-content .order-success-info {
  width: 920px;
  margin: 0 auto;
  color: #00a724;
  font-size: 18px;
  margin-top: 20px;
}
.order-details-content .order-step {
  width: 920px;
  margin: 0 auto;
  margin-top: 40px;
}
/*进度条区域END*/
/*订单商品区域*/
.order-details-content .order-list-product {
  width: 920px;
  height: 110px;
  background-color: #ffffff;
  margin: 0 auto;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
}
.order-details-content .order-list-product .pro-img {
  margin-right: 20px;
}
.order-details-content .order-list-product .pro-img img {
  height: 80px;
  width: 80px;
}
.order-details-content .order-list-product .pro-info {
  font-size: 15px;
  color: #333333;
}
.order-details-content .order-list-product .pro-info .info-href {
  font-size: 15px;
  color: #333333;
}
.order-details-content .order-list-product .pro-info .info-href:hover {
  color: #B9365B;
}
.order-details-content .order-list-product .pro-price {
  margin-left: 30px;
  font-size: 15px;
  color: #333333;
}

/*订单商品区域END*/
/*订单收货信息区域*/
.order-details-content .order-address-title {
  width: 1020px;
  margin: 0 auto;
  color: #242424;
  font-size: 18px;
  margin-top: 20px;
}
.order-details-content .order-address {
  width: 920px;
  height: 120px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
}
.order-details-content .order-address .order-address-head {
  font-size: 15px;
  line-height: 25px;
  font-weight: bold;
  color: #757575;
}
.order-details-content .order-address .order-address-data {
  font-size: 15px;
  line-height: 25px;
  color: #757575;
}
/*订单收货信息区域END*/

/* 结算列表CSS */
.order-details-content .section-count {
  margin: 0 48px;
  padding: 20px 0;
  overflow: hidden;
}
.order-details-content .section-count .money-box {
  float: right;
  text-align: right;
}
.order-details-content .section-count .money-box .title {
  float: left;
  width: 240px;
  height: 30px;
  display: block;
  line-height: 30px;
  color: #757575;
}
.order-details-content .section-count .money-box .value {
  float: left;
  min-width: 105px;
  height: 30px;
  display: block;
  line-height: 30px;
  color: #B9365B;
}
.order-details-content .section-count .money-box .total .title {
  padding-top: 15px;
}
.order-details-content .section-count .money-box .total .value {
  padding-top: 10px;
}
.order-details-content .section-count .money-box .total-price {
  font-size: 30px;
}
/* 结算列表CSS END */

/*v-else*/
.order-details .not-found {
  height: 500px;
  text-align: center;
}
/*v-else END*/

/* 手机端适配 */
@media (max-width: 900px) {
  .order-details-layout {
    max-width: 100%;
  }
  .order-details-title {
    height: auto;
    padding: 12px;
  }
  .order-details-title p {
    margin-left: 0;
    font-size: 22px;
  }
  /* 操作条与步骤信息 */
  .order-details-content .order-operate,
  .order-details-content .order-step-info,
  .order-details-content .order-success-info,
  .order-details-content .order-step {
    width: 100%;
    padding: 0 12px;
  }
  .order-details-content .order-operate {
    flex-wrap: wrap;
  }
  .order-details-content .order-operate .order-num {
    width: auto;
    margin-bottom: 8px;
  }
  .order-details-content .order-operate .order-button {
    margin-left: 0;
  }
  /* 商品列表 */
  .order-details-content .order-list-product {
    width: 100%;
    height: auto;
    padding: 12px;
    flex-wrap: wrap;
  }
  .order-details-content .order-list-product .pro-img {
    margin-right: 12px;
  }
  .order-details-content .order-list-product .pro-img img {
    width: 64px;
    height: 64px;
    border-radius: 6px;
  }
  /* 收货信息与结算列表 */
  .order-details-content .order-address-title,
  .order-details-content .order-address {
    width: 100%;
    padding: 0 12px;
    height: auto;
  }
  .order-details-content .section-count {
    margin: 0;
    padding: 16px 12px;
  }
  .order-details-content .section-count .money-box {
    float: none;
    text-align: left;
  }
}
</style>
